import React, { PureComponent, PropTypes } from 'react';
import { Icon, LinkButton } from 'react-fast-ui';
import { commonPropTypes } from '../../util/constants';
import cx from 'classnames';

const ICON_SIZE_MAP = {
  xs: '',
  sm: '1x',
  md: 'lg',
  lg: '2x',
  xl: '3x'
};

export default class IconButton extends PureComponent {
  static propTypes = {
    color: PropTypes.string,
    colorOverride: PropTypes.bool,
    disabled: PropTypes.bool,
    fontSize: commonPropTypes.SIZES,
    icon: PropTypes.string.isRequired,
    iconSize: commonPropTypes.SIZES,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string,
  };

  static defaultProps = {
    color: 'primary',
    colorOverride: false,
    disabled: false,
    fontSize: 'xs',
    iconSize: 'md',
    text: null
  };

  render() {
    const { className, color, colorOverride, disabled, fontSize, icon, iconSize, onClick, style, text } = this.props;
    const parentClasses = cx(
      'align-items-center',
      { 'cursor-pointer': !disabled },
      { 'cursor-not-allowed': disabled },
      { 'color-light-gray': !colorOverride || disabled },
      'display-flex',
      'flex-direction-column',
      { [ `hover-color-${color}` ]: !disabled },
      'hover-visibility-parent',
      className
    );
    const textClasses = cx(
      `${fontSize}-font`,
      `mg-top-${fontSize}`,
      'visibility-hidden',
      'visibility-child-visible'
    );

    return (
      <LinkButton className={parentClasses} onClick={disabled ? null : onClick} style={style}>
        <Icon name={icon} size={ICON_SIZE_MAP[ iconSize ]}/>
        {text ? <div className={textClasses}>{text}</div> : null}
      </LinkButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/layout/IconButton.jsx